export default __webpack_public_path__ + "static/images/stay-in-loop.4c7b4e63.png";